import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Volumen 1 — El Código de la Modulación',
    items: ['Entendés por qué tu digestión cambió después de los 55 y cómo revertirlo', 'Descubrís el método que resetea tu microbiota desde cero', 'Identificás si tenés permeabilidad intestinal sin estudios caros', 'Conectás los puntos entre tu intestino, tu humor y tu energía', 'Arrancás con un diagnóstico personal claro desde el primer día'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Volumen 2 — Protocolo Desinflamatorio 21 Días',
    items: ['Seguís un menú completo de 21 días organizado en 3 fases simples', 'Sabés exactamente qué comer y qué evitar sin adivinar', 'Desinflamás sin pasar hambre ni afectar tu energía', 'Avanzás de una fase a la siguiente sin retroceder ni confundirte', 'Arrancás el Día 1 hoy mismo, sin preparación previa'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Volumen 3 — Guía de Compras Argentina',
    items: ['Detectás los aditivos ocultos que te inflaman sin que lo sepas', 'Sabés qué marcas argentinas realmente funcionan y cuáles evitar', 'Elegís frutas y verduras de estación que no te van a inflamar', 'Distinguís lo "saludable" de lo verdaderamente desinflamatorio', 'Llevás una lista de compras lista para imprimir o guardar en el celular'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Volumen 4 — Recetario Panza Plana',
    items: ['Disfrutás 50 recetas ricas sin gluten ni lácteos que inflaman', 'Reemplazás tus pizzas, panes y postres favoritos sin sentir que te privás', 'Conseguís todos los ingredientes en tu verdulería o super de barrio', 'Preparás cada receta con técnicas simples que potencian los beneficios', 'Sabés el tiempo, el paso a paso y los tips de liviandad de cada plato'],
    color: 'border-red-500/30'
  }, {
    emoji: '📒',
    title: 'Volumen 5 — SOS Gases y Acidez',
    items: ['Actuás de inmediato ante una crisis con un protocolo de 24 horas', 'Usás hierbas medicinales argentinas con confianza y resultados reales', 'Aliviás los gases con técnicas de automasaje que hacés en casa ahora mismo', 'Entendés la causa raíz de tu acidez y dejás de tratar solo el síntoma', 'Mejorás tu tránsito con pequeños cambios posturales sin esfuerzo'],
    color: 'border-yellow-500/30'
  }, {
    emoji: '📓',
    title: 'Volumen 6 — Diario de Transformación',
    items: ['Registrás tus síntomas, energía y sueño de forma simple cada día', 'Entendés tu salud digestiva con la Escala de Bristol adaptada para vos', 'Verificás semanalmente que estás aplicando bien el protocolo', 'Distinguís el hambre emocional del hambre real para decidir mejor', 'Ves con tus propios ojos cuánto cambiaste en 21 días'],
    color: 'border-gray-500/30'
  }];
  const includes = ['Plan diario listo para arrancar hoy', 'Recetas paso a paso con ingredientes locales', 'Guía de compras argentina', 'Tracker de síntomas con criterios claros', 'Errores frecuentes y cómo evitarlos', 'Checklist imprimible por etapa'];
  return <section className="py-24 bg-brand-dark" data-id="element-202">
      <div className="container mx-auto px-4" data-id="element-203">
        <div className="max-w-5xl mx-auto" data-id="element-204">
          <div className="text-center mb-16" data-id="element-205">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-206">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-207">
                🏆 SISTEMA RESCATE INTESTINAL +55™
              </h2>
              <p className="text-2xl text-white font-medium mb-2" data-id="element-208">
                Tu hoja de ruta completa de 21 días para resetear tu digestión,
                recuperar tu energía y volver a comer sin miedo.
              </p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-209">
            📚 6 VOLÚMENES COMPLETOS
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-210">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-211">
                <div className="text-5xl shrink-0" data-id="element-212">{tomo.emoji}</div>
                <div data-id="element-213">
                  <h4 className="text-xl font-bold text-white mb-3" data-id="element-214">
                    {tomo.title}
                  </h4>
                  <ul className="space-y-2" data-id="element-215">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-216">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-217" />
                        <span data-id="element-218">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-219">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-220">
              El Sistema incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-221">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-222">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-223" />
                  <span className="text-gray-200" data-id="element-224">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}